import React, { useState } from 'react'
// import { API_BASE } from 'api';
import { API_BASE } from '../api';
import Header from '../components/Header';
import Footer from '../components/Footer';

const initialForm = {
  topic: "I am looking for product information",
  name: "",
  mobile: "",
  email: "",
  company: "",
  message: "",
};


function Contact() {
  const page = "contact";
  // put this inside your component

  const [form, setForm] = useState(initialForm);
  const [status, setStatus] = useState("idle");

  const onChange = (e) => {
    const { name, type, value, checked } = e.target;
    setForm((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };
  
  const handleReset = () => {
    setForm(initialForm);
  };  

  const handleSubmit = async (e) => {
    e.preventDefault();
    // if (!form.name?.trim()) {
    //   alert("Please enter your name.");
    //   return;
    // }
    // if (!form.email?.trim()) {
    //   alert("Please enter your email.");
    //   return;
    // }
    // if (!form.mobile?.trim()) {
    //   alert("Please enter your mobile number.");
    //   return;
    // }    
    setStatus("submitting");
    // console.log("hello");
    try {
      const fd = new FormData();
      fd.append("topic", form.topic);
      fd.append("name", form.name);
      fd.append("mobile", form.mobile);
      fd.append("email", form.email);
      fd.append("company", form.company);
      fd.append("message", form.message || "");

      // Debug
      // for (const [k, v] of fd.entries()) {
      //   console.log("FD", k, v instanceof File ? `File(${v.name})` : v);
      // }

      const res = await fetch(`${API_BASE}/admin/send-email`, {
        method: "POST",
        body: fd, // don't set Content-Type; the browser will
      });

      const data = await res.json().catch(() => ({}));
      console.log("status", res.status, data);

      if (!res.ok) {
        alert(data.message || `Bad request (${res.status})`);
        setStatus("error");
        return;
      }

      alert("Submitted!");
      handleReset();
      setStatus("success");
    } catch (err) {
      console.error(err);
      alert("Something went wrong. Please try again.");
      setStatus("error");
    } finally {
      setStatus("idle");
    }
  };

  return (
    <div>
      {/* <Header /> */}
      <section className={`hero ${page}`}>
        <h1>Contact Us</h1>
      </section>

      {/* GET IN TOUCH */}
      <section className="contact-section">
        <div className="contact-image"></div>

        <div className="contact-form-container">
          <h2>Get in touch</h2>
          <p>Please use the form below to send us a message. Our team will get back to you as soon as possible.</p>

          <form onSubmit={handleSubmit}>
            <select name="topic" value={form.topic} onChange={onChange}>
              <option>I am looking for product information</option>
              <option>I am a customer</option>
              <option>I am press</option>
              <option>I am an investor</option>
              <option>I am looking for a quote</option>
              <option>I am looking for general information</option>
              <option>I am a supplier</option> 
            </select>
            <input type="text" name="name" placeholder="Name" required value={form.name} onChange={onChange} />
            <input type="text" name="mobile" placeholder="Mobile" required value={form.mobile} onChange={onChange} />
            <input type="email" name="email" placeholder="Email address" required value={form.email} onChange={onChange} />
            <input type="text" name="company" placeholder="Company name" value={form.company} onChange={onChange}/>
            <textarea name="message" placeholder="Message" required value={form.message} onChange={onChange}></textarea>

            {/* <label>
              <input type="checkbox"> Yes, I agree to the privacy terms
            </label> */}

            <button type="submit" disabled={status === "submitting"}>
              {status === "submitting" ? "Sending…" : "Send"}
              <svg width="60" height="24" viewBox="0 0 64 24" fill="none">
                <path d="M0 12h50M43 5l7 7-7 7" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <button type="button" onClick={handleReset}>Reset</button>
          </form>
        </div>
      </section>
      {/* <Footer /> */}
    </div>
  )
}

export default Contact